import React, { Component } from "react";
import axios from "axios";
import styled from "styled-components";
import { Link, withRouter } from "react-router-dom";
import * as _ from "lodash-joins";

import Map from "./Map.jsx";
import AS from "../Login/Service/Authentication.js";
import { ROUTES } from "../../commons/constants/routes/routes.js";
import MapGoogle from "./MapGoogle.jsx";

/**
 * 2024.08.19
 */
class ProjectMap extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chkbox: true,
      points: [],
      totalCount: 0,
    };
    this.getItems = this.getItems.bind(this);
    this.handleChangeChk = this.handleChangeChk.bind(this);
    this.handleMapClick = this.handleMapClick.bind(this);
  }

  componentDidMount() {
    this.getItems(1);
  }

  async getItems(pageIndex) {
    let constructorId = AS.getLoggedInId();

    try {
      const res = await axios.get(`/cst/api/project/${constructorId}`);
      const projects = res.data.data;
      // console.log(projects)
      // console.log(projects.length)

      const points = _.chain(projects)
        .groupBy((v) => `${v.lngX},${v.latY}`)
        .map((groups, xy) => ({ xy, groups }))
        .value();
      
      // console.log(points.length)

      this.setState({
        points: points,
        totalCount: projects.length,
      });
    } catch (e) {
      console.log(e);
    }
  }

  handleChangeChk(e) {
    this.setState({ chkbox: e.target.checked });
  }

  handleMapClick() {
    this.props.history.push(ROUTES.PROJECT.MAIN);
  }

  render() {
    const { chkbox, points } = this.state;
    return (
      <PlantListWrap>
        <div className="page-tit gray">
          <div className="container f-stack">
            <h2 className="tit">프로젝트</h2>
            <Link to={ROUTES.PROJECT.CREATE} className="btn primary">
              프로젝트 등록
            </Link>
          </div>
        </div>
        <div className="container">
          <div className="top-search">
            <p className="all">
              전체보기<span> 총 {this.state.totalCount}개</span> 
            </p>
            <div className="search">
              <form onSubmit={(e) => e.preventDefault()}>
                <select id="orderType" title="정렬선택">
                  <option value="">정렬</option>
                  <option value="DESC">최근순</option>
                  <option value="Asc">과거순</option>
                </select>
                <select id="searchType" title="종류선택">
                  <option value="">검색종류</option>
                  <option value="addr">주소</option>
                  <option value="plant">발전소명</option>
                </select>
                <div className="input-search">
                  <input type="text" id="keyword" placeholder="입력" />
                  <input type="hidden" />
                  <button
                    type="button"
                    className="material-icons"
                    onClick={() => this.getItems(1)}
                  >
                    search
                  </button>
                </div>
              </form>
              <div className="map-box">
                <label htmlFor="idCheck" onClick={this.handleMapClick}>
                  <input
                    type="checkbox"
                    id="idCheck"
                    defaultChecked={chkbox}
                    // onChange={this.handleChangeChk}
                  />{" "}
                  지도로 보기
                </label>
              </div>
            </div>
          </div>

          <div className="card map" id="map" style={{ height: "550px" }}>
            <MapGoogle points={points} />
          </div>
        </div> 
      </PlantListWrap>
    );
  }
}

const PlantListWrap = styled.div`
  .page-tit .btn {
    width: 168px;
    border-radius: 8px;
  }
  .top-search .all {
    font-size: 15px;
    font-weight: bold;
    color: #191919;
    span {
      font-weight: normal;
      color: #888e98;
      display: inline-block;
      margin-left: 10px;
    }
  }
  .map-box {
    display: inline-block;
    input {
      display: inline-block;
      margin: 0 5px 0 12px;
    }
    label {
      display: inline-block;
    }
  }
  .search form {
    select {
      border: 1px solid #d5d8de;
      margin-right: 12px;
    }
  }
  .link-btn {
    display: inline-block;
    font-size: 12px;
    width: 45px;
    padding: 3px 0;
    text-align: center;
    border-radius: 5px;
    text-decoration: none;
  }
  .ems-link {
    background-color: #d5d8de;
    border: 1px solid #d5d8de;
    &:hover {
      background-color: #b9bcc3;
      border: 1px solid #b9bcc3;
    }
  }
  .plant-link {
    background-color: var(--primary-500);
    border: 1px solid var(--primary-500);
    color: var(--grey-900);
    margin: 0 5px;
    &:hover {
      background-color: var(--primary-600);
      border: 1px solid var(--primary-600);
    }
  }
  .edit-link {
    background-color: var(--secondary-500);
    border: 1px solid var(--secondary-500);
    color: var(--white);
    &:hover {
      background-color: var(--secondary-600);
      border: 1px solid var(--secondary-600);
    }
  }
`;

export default withRouter(ProjectMap);
